module.exports = __webpack_public_path__ + "static/media/Beam Club Logo Final_1727903352831.87eb0ee7.png";